import { BASE_S3_URL } from "./constant";

export const DEFAULT_PATH = BASE_S3_URL;
export const LOGO_BIG = BASE_S3_URL + '../logo-big.png'; //'/images/logo-590x164.png';
export const DEFAULT_IMAGE_PATH = BASE_S3_URL + 'campaigns/default-image/default-image.png';
export const PATRON_BG = BASE_S3_URL + 'patron/patron-bg.png';
export const ACHIEVEMENT_BG = BASE_S3_URL + 'patron/achievement-bg.png';
export const BANNER_ONE = BASE_S3_URL + 'banner/banner-1.png';
export const APPEAL_ONE = BASE_S3_URL + 'appeals/appeal-1.png';
export const NGS_IMG_BANNER_MAIN = BASE_S3_URL + 'banner/national-gallery-mainimage.jpg';


/** CARD IMAGES - .SVG */
export const FACEBOOK_IMG = BASE_S3_URL + '../social/facebook.svg';
export const TEL_IMG = BASE_S3_URL + 'contact/tel.svg';
export const EMAIL_IMG = BASE_S3_URL + 'contact/email.svg';
export const ADDRESS_IMG = BASE_S3_URL + 'contact/address.svg';
export const TEL_2_IMG = BASE_S3_URL + 'contact/tel-2.svg';
export const EMAIL_2_IMG = BASE_S3_URL + 'contact/email-2.svg';
export const EDIT_ICON = BASE_S3_URL + 'edit.svg';
export const CLOSE_DARK = BASE_S3_URL + 'close-dark.svg';
export const TICK_CIRCLE_BIG = BASE_S3_URL + 'tick-circle-big.svg';
export const TICK_SUCCESS_GRAPHIC = BASE_S3_URL + 'tick-success-graphic.svg';
export const ENROLE_MANUALLY = BASE_S3_URL + 'enrole-manually.svg';
export const ARROW_NEXT_WHITE = BASE_S3_URL + 'arrow-next-white.svg';
export const ARROW_UP_DOWN = BASE_S3_URL + 'arrow-up-down.svg';
export const CLOSE_RED = BASE_S3_URL + 'close-red.svg';
export const ICON_USER_PROFILE_IMG = BASE_S3_URL + 'icon-user-profile.svg';
export const ICON_USER_PROFILE = BASE_S3_URL + 'icon-user-profile-42x42.svg'
export const ICON_USER_PROFILE_PATRON = BASE_S3_URL + 'patron/icon-user-profile-patron.svg'
export const DOT_OPTIONS = BASE_S3_URL + 'dot-options.svg'
export const POPUP_CLOSE = BASE_S3_URL + 'popup-close.svg'
export const MARK_EXCLAMATION = BASE_S3_URL + 'exclamation-mark.svg';
export const MARK_EXCLAMATION_RED_13x13 = BASE_S3_URL + 'exclamation-red-13x13.svg';
export const MARK_EXCLAMATION_17x17 = BASE_S3_URL + 'exclamation-mark-17x17.svg';
export const ENROLE_MANUALLY_BLACK = BASE_S3_URL + 'enrole-manually-black.svg'
export const EYE_PASSWORD = BASE_S3_URL + 'eye-password.svg'
export const EYE_PASSWORD_OPEN = BASE_S3_URL + 'eye-password-open.svg'
export const MARK_EXCLAMATION_IMG = BASE_S3_URL + 'exclamation-mark-17x17px.svg'
export const ARROW_BACK_RED = BASE_S3_URL + 'arrow-back-red.svg'
export const IMAGE_POPUP = BASE_S3_URL + 'image-popup.svg'
export const ARROW_PREW_CIRCLE = BASE_S3_URL + 'arrow-prev-circle.svg'
export const ARROW_NEXT_CIRCLE = BASE_S3_URL + 'arrow-next-circle.svg'
export const ICON_LOCATION = BASE_S3_URL + 'icon-location.svg'
export const SIGN_PLUS = BASE_S3_URL + 'sign-plus.svg'
export const SIGN_MINUS = BASE_S3_URL + 'sign-minus.svg'
export const SLIDER_NAV_ARROW_BIG = BASE_S3_URL + 'slider-nav-arrow-big.svg';
export const ICON_RECEIPT = BASE_S3_URL + 'receipt.svg';
export const ICON_BACK = BASE_S3_URL + 'icon-back.svg';
export const ICON_ARROW_BACK_GRAY = BASE_S3_URL + 'arrow-back-gray.svg';
export const LOGO_GIVEPLEASE = BASE_S3_URL + 'logo-giveplease.svg';
export const ICON_SHARE = BASE_S3_URL + 'social/icon-share.svg';
export const CAUSE_FUNDS = BASE_S3_URL + 'causes/small/funds.svg';
export const CAUSE_COLLECTIONS = BASE_S3_URL + 'causes/small/collections.svg';
export const CAUSE_COMMUNITY = BASE_S3_URL + 'causes/small/community.svg';
export const CAUSE_EDUCATION = BASE_S3_URL + 'causes/small/education.svg';
export const CAUSE_EXHIBITIONS = BASE_S3_URL + 'causes/small/exhibitions.svg';
export const CAUSE_CURATORIAL = BASE_S3_URL + 'causes/small/curatorial.svg';


/** CARD IMAGES - .PNG */
export const CARD_DEFAULT = BASE_S3_URL + 'cards/default-195x125.png';
export const CARD_AMERICAN = BASE_S3_URL + 'cards/american-express-195x125.png';
export const CARD_DINERS_CLUB = BASE_S3_URL + 'cards/diners-club-195x125.png';
export const CARD_JCB = BASE_S3_URL + 'cards/jcb-195x125.png';
export const CARD_MASTER_CARD = BASE_S3_URL + 'cards/master-card-195x125.png';
export const CARD_UNION_PAY = BASE_S3_URL + 'cards/union-pay-195x125.png';
export const CARD_VISA = BASE_S3_URL + 'cards/visa-195x125.png';
export const CARD_GOOGLE = BASE_S3_URL + 'cards/g-pay.png';
export const CARD_APPLE_PAY = BASE_S3_URL + 'cards/apple-pay.png';
export const CARD_ALIPAY = BASE_S3_URL + 'cards/alipay.png';
export const CARD_GRABPAY = BASE_S3_URL + 'cards/grab-pay.png';
export const CARD_PAYNOW = BASE_S3_URL + 'cards/pay-now.png';
export const CARD_CASH = BASE_S3_URL + 'cards/cash-195x125.png';
export const CARD_CHEQUE = BASE_S3_URL + 'cards/cheque-195x125.png';
export const CARD_NETS = BASE_S3_URL + 'cards/nets-195x125.png';

/** CARD IMAGES - .SVG */
export const CARD_GOOGLE_SVG = BASE_S3_URL + 'cards/g-pay.svg';
export const CARD_APPLE_PAY_SVG = BASE_S3_URL + 'cards/applepay.svg';
export const CARD_ALIPAY_SVG = BASE_S3_URL + 'cards/alipay.svg';
export const DOTS_VERTICAL_3 = BASE_S3_URL + 'cards/vertical-dots-3.svg';
export const DOTS_HORIZONTAL_3 = BASE_S3_URL + 'cards/horizontal-card-dots.svg';
export const CARD_ADD_GRAPHICS = BASE_S3_URL + 'cards/add-card-graphic.svg';
export const CARD_GRABPAY_SVG = BASE_S3_URL + 'cards/grab-pay.svg';
export const PAYNOW_SVG = BASE_S3_URL + 'cards/pay-now.svg';


/** SOCIAL ICONS */
export const SOCIAL_ICON_SHARE = BASE_S3_URL + 'social/share-feature-icons/';
export const SOCIAL_ICON = BASE_S3_URL + 'social/';


/** CONTACTS - .SVG */
export const CONTACT_ADDRESS = BASE_S3_URL + 'contact/address.svg';
export const CONTACT_EMAIL = BASE_S3_URL + 'contact/email.svg';
export const CONTACT_TEL = BASE_S3_URL + 'contact/tel.svg';
export const SLIDER_NAV_ARR_BIG =  BASE_S3_URL  + 'slider-nav-arrow-big.svg';

// payment cards
export const PAYMENT_APPLE =  BASE_S3_URL  + 'payment/apple-pay.svg';
export const PAYMENT_ALIPAY =  BASE_S3_URL  + 'payment/alipay.svg';
export const PAYMENT_GPAY =  BASE_S3_URL  + 'payment/g-pay.svg'; 

